import {Injectable} from '@angular/core';

import en from './languages/en.json';
import pl from './languages/pl.json';
import de from './languages/de.json';
import {CookieService} from 'ngx-cookie-service';

type LanguageDictionary = Record<string, Record<string, string>>;

@Injectable()
export class LanguageService{
    selectedLanguage = this.cookieService.get('language');
    segmentsNames: any = {};
    constantSegmentNames: any = {};
    language: LanguageDictionary = pl as LanguageDictionary;

    constructor(private cookieService: CookieService) {
        if (this.selectedLanguage === 'en') {
            this.language = en;
        }
        else if (this.selectedLanguage === 'pl'){
            this.language = pl;
        }
        else if (this.selectedLanguage === 'de'){
            this.language = de;
        }
        else {
            const defaultLanguage = this.detectDefaultLanguage();
            this.cookieService.set('language', defaultLanguage);
            this.selectedLanguage = defaultLanguage;
            this.language = defaultLanguage === 'pl' ? pl : defaultLanguage === 'de' ? de : en;
        }
    }

    private detectDefaultLanguage(): 'pl' | 'en' | 'de' {
        const browserLanguages = navigator.languages && navigator.languages.length
            ? navigator.languages
            : [navigator.language || 'en'];

        if (browserLanguages.some((language) => language.toLowerCase().startsWith('pl'))) {
            return 'pl';
        }
        if (browserLanguages.some((language) => language.toLowerCase().startsWith('de'))) {
            return 'de';
        }
        return 'en';
    }

    getLang(value: string, page: string, args?: any): any {
        if (this.language[page][value]) {
            return this.language[page][value];
        }
        return value;
    }

    changeLanguage(language: string): void{
        if (language === 'pl') {
            this.selectedLanguage = 'pl';
            this.language = pl;
            this.cookieService.set('language', 'pl');
        }
        else if (language === 'en') {
            this.selectedLanguage = 'en';
            this.language = en;
            this.cookieService.set('language', 'en');
        }
        else if (language === 'de') {
            this.selectedLanguage = 'de';
            this.language = de;
            this.cookieService.set('language', 'de');
        }
        else {
            this.selectedLanguage = 'en';
            this.language = en;
            this.cookieService.set('language', 'en');
        }
    }
}
